import React, { useContext } from "react";
import { AppContext } from "../../../../AppContext";
import "../../Button.css";
import { logActivity } from "../../../utils";

const GeneratePreApprovalButton = ({
  clientName,
  loanOfficerName,
  loanOfficerEmail,
  loanOfficerPhone,
  agentPartner,
  agentEmail,
  agentPhone,
  coAgentPhone,
  preApprovalAmt,
  downpaymentPercentage,
  downpaymentDollar,
  loanProgram,
  googleTemplateID,
  googleFolderId,
  preApprovalNames,
  loanOfficerTextNotifications,
  agentTextNotifications,
  coAgentTextNotifications,
}) => {
  const {
    setGeneratePreApprovalModal,
    setInputPreApprovalNames,
    makeKey,
    userType,
    userEmail,
    userCompany,
  } = useContext(AppContext);

  return (
    <div
      id="prioritizeClick"
      className="button"
      onClick={() => {
        setInputPreApprovalNames(preApprovalNames);
        setGeneratePreApprovalModal({
          status: "active",
          clientName: clientName,
          preApprovalAmount: preApprovalAmt,
          loanOfficerName: loanOfficerName,
          loanOfficerEmail: loanOfficerEmail,
          agentPartner: agentPartner,
          agentEmail: agentEmail,
          loanOfficerPhone: loanOfficerPhone,
          agentPhone: agentPhone,
          coAgentPhone: coAgentPhone,
          downpaymentPercentage: downpaymentPercentage,
          downpaymentDollar: downpaymentDollar,
          loanProgram: loanProgram,
          googleTemplateID: googleTemplateID,
          googleFolderId: googleFolderId,
          preApprovalNames: preApprovalNames,
          loanOfficerTextNotifications: loanOfficerTextNotifications,
          agentTextNotifications: agentTextNotifications,
          coAgentTextNotifications: coAgentTextNotifications,
        });
        logActivity({
          apiKey: makeKey,
          userEmail: userEmail,
          userType: userType,
          action: "Generate Pre Approval Button",
          tab: "Pre-Approvals",
          userCompany: userCompany,
        });
      }}
    >
      Generate Pre-Approval
    </div>
  );
};

export default GeneratePreApprovalButton;
